/* @flow */
import * as React from 'react';

import Dialog from 'components/Dialog.jsx';
import OrganizationCreate from './OrganizationCreate.jsx';

type Props = {
  defaultOrganization?: string,
  onCreate: (*) => void,
  onRequestHide: () => void,
  organizationType?: OrganizationType,
};

class OrganizationCreateModal extends React.Component<Props, $FlowFixMeState> {
  render() {
    const { organizationType } = this.props;
    return (
      <Dialog
        onRequestHide={this.props.onRequestHide}
        eventScreenName="OrganizationCreateModal"
        title={`Add your ${organizationType ? organizationType.toLowerCase() : 'organization'}`}
        size="small">
        <OrganizationCreate {...this.props} />
      </Dialog>
    );
  }
}

export default OrganizationCreateModal;
